export enum MessageType {
  regular = 'regular',
  loader = 'loader',
  toolPromo = 'tool_promo',
}
